/** Живой виджет в ответе ИИ — лениво: код страниц и карты грузится, только когда он пришёл. */
import { lazy, Suspense } from 'react';
import { SkeletonCard } from '../../astra/ui';
import { ErrorBoundary } from '../../astra/ui/ErrorBoundary';
import type { AiWidgetSpec } from './spec';

const AiWidget = lazy(() => import('./AiWidget').then((mod) => ({ default: mod.AiWidget })));

/**
 * Граница стоит снаружи `Suspense`: не догрузившийся код виджета (сеть, новая
 * сборка) бросает ошибку при загрузке модуля, и без границы она роняла бы
 * всю панель или страницу отчёта.
 */
export function LazyAiWidget({ spec }: { spec: AiWidgetSpec }) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<SkeletonCard />}>
        <AiWidget spec={spec} />
      </Suspense>
    </ErrorBoundary>
  );
}
